module.exports = __webpack_public_path__ + "static/media/icon-covid-global-confirmed.efd1a3bc.svg";